import React, { useEffect } from 'react';

export interface LogEventType {
  eventName: string;
  eventParams: Record<string, any>
}

interface MentionedUserPropType {
  dataType: string;
  dataName: string;
  dataId: string;
  href: string; // user_unique_name href
  onMentionedClick: (topicHref: string, dataId: string) => void;
  onLogEvent: (data: LogEventType) => void;
};

export const MentionedUserAnchor: React.FC<MentionedUserPropType> = props => {

  const { dataName, dataId, href, onMentionedClick, onLogEvent } = props;

  const handleItemClick = (e: any) => {
    e.preventDefault();
    onMentionedClick(href, dataId);
  };

  return (
    <a
      onClick={handleItemClick}
      key={`mentioned-user-${dataId}`}
      href={href}
      className="l8editor-mention"
    >
      {dataName}
    </a>
  );
};
